import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Translator from 'translator';
import { Map } from 'immutable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { withStyles } from '@material-ui/core';
import { Toastr } from 'data/common';
import { FHEContainer } from 'data/components';
import ProductDetail from 'environments/fhe/scenes/Products/components/Product/ProductDetail';
import { getProductsDetails, refreshProductStatus } from '../../data/Products/actions';

class ProductsDetails extends Component {
    static propTypes = {
        getProductsDetails: PropTypes.func.isRequired,
        match: PropTypes.object.isRequired,
        initialized: PropTypes.bool.isRequired,
        productKey: PropTypes.string,
        fheCenter_mac: PropTypes.string,
        middleware: PropTypes.string,
        productType: PropTypes.string,
        moduleType: PropTypes.string,
        refreshProductStatus: PropTypes.func
    };

    static defaultProps = {
        productKey: null,
        fheCenter_mac: null,
        productType: null,
        middleware: null,
        moduleType: null,
        refreshProductStatus: null
    };

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            error: null
        };
    }

    componentDidMount() {
        this.getProductsDetails();
    }

    getProductsDetails = () => {
        const { loading, error } = this.state;
        const { getProductsDetails, match } = this.props;

        if (!loading || error) this.setState({ loading: true, error: null });

        getProductsDetails(match.params.homeId, match.params.productType, match.params.productIdentifier)
            .then(() => {
                this.setState({
                    loading: false,
                    error: null
                });
            })
            .catch(err => {
                const message = Translator.translateWithFallback(`api.message.${err.message ? err.message : err}`, 'api.message.default');
                Toastr.error(message);
                this.setState({
                    error: message,
                    loading: false
                });
            });
    };

    refreshStatusProduct = (productType, productMac) => {
        const { refreshProductStatus, middleware } = this.props;
        return refreshProductStatus(middleware, productMac, productType)
            .then(() => {
                Toastr.success(Translator.translate('generic.products.table.action.refresh.success'));
            })
            .catch(err => {
                Toastr.error(
                    Translator.translateWithFallback(`socket.error.${err.message ? err.message : err}`, 'socket.error.defaultError'),
                    Translator.translate('generic.products.table.action.refresh.error')
                );
            });
    };
    renderChildren = () => {
        const { productKey, productType, moduleType } = this.props;

        return (
            <ProductDetail
                productKey={productKey}
                productType={productType}
                moduleType={moduleType}
                refreshStatusProduct={this.refreshStatusProduct}
            />
        );
    };

    render() {
        const { loading, error } = this.state;
        const { initialized } = this.props;
        return (
            <FHEContainer
                withBackIcon
                loading={loading && !initialized}
                error={error}
                onClickFunc={this.getProductsDetails}
                onRender={this.renderChildren}
            />
        );
    }
}

function mapStateToProps(state, props) {
    const key = `${props.match.params.homeId}_${props.match.params.productType}_${props.match.params.productIdentifier}`;
    const product = state.environments.fhe.data.Products.getIn(['list', key], new Map());
    let fheCenter_mac = null;
    let middleware = null;
    state.environments.fhe.data.Boxes.get('list').map((box, macAddress) => {
        if (box.get('homeId') === product.get('homeId')) {
            fheCenter_mac = macAddress;
            middleware = box.get('middleware');
        }
    });
    return {
        profile: state.data.user,
        productKey: key,
        productType: product.get('productType'),
        moduleType: product.get('type'),
        initialized: state.environments.fhe.data.Products.get('initialized'),
        fheCenter_mac,
        middleware
    };
}

const styles = () => ({
    loadingContainer: {
        textAlign: 'center',
        margin: 20
    }
});

export default withRouter(
    connect(
        mapStateToProps,
        dispatch => bindActionCreators({ getProductsDetails, refreshProductStatus }, dispatch)
    )(withStyles(styles, { withTheme: true })(ProductsDetails))
);



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Products/details.js